import "./WithdrawAmcAndHewe.scss";

export const WithdrawAmcAndHewe = () => {
  return <div className="WithdrawAmcAndHewe">WithdrawAmcAndHewe</div>;
};
